import { number, shape, string } from 'prop-types';

const userDetailsType = shape({
  id: number,
  firstName: string,
  lastName: string,
  email: string,
  countryCode: string,
  preferredUnits: string,
});

export default userDetailsType;
